import React from 'react';
import { Image } from 'react-bootstrap';

import GooglePlayStore from '../../images/app-store-google.svg';
import AppleStore from '../../images/app-store-apple.svg';

const AppLinks = () => (
  <ul className="Footer-Promoted__App">
    <li>
      <a href="!#">
        <Image 
          fluid 
          src={AppleStore} 
        />
      </a>
    </li>
    <li>
      <a href="!#">
        <Image 
          fluid 
          src={GooglePlayStore} 
        />
      </a>
    </li>
  </ul>
);

export default AppLinks;